import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Alert } from '@zillow/constellation';
import {
  getIsCreditReportNoRecordFoundSelector,
  getIsCreditReportUnavailableSelector,
  getWasRetrieveSharedReportsGatewayTimeoutSelector,
} from '../../../../../../../selectors/sharedReports';
import GatewayTimeoutAlertBody from '../../../../../../../components/CustomerSupport/GatewayTimeoutAlertBody';
import CustomerSupportLink from '../../../../../../../components/CustomerSupport/CustomerSupportLink';

function CreditReportGeneralAlert({ applicant }) {
  const { userId: applicantId } = applicant;
  const isCreditReportUnavailable = useSelector(getIsCreditReportUnavailableSelector(applicantId));
  const isCreditReportNoRecordFound = useSelector(getIsCreditReportNoRecordFoundSelector(applicantId));
  const didRetrievalFailOnGatewayTimeout = useSelector(getWasRetrieveSharedReportsGatewayTimeoutSelector(applicantId));

  let body = null;
  // Don't show general alert if report will never be available
  if (!isCreditReportNoRecordFound) {
    if (didRetrievalFailOnGatewayTimeout) {
      body = GatewayTimeoutAlertBody;
    } else if (isCreditReportUnavailable) {
      body = (
        <>Credit report can’t be pulled due to an error. Please contact {CustomerSupportLink} to report the issue.</>
      );
    }
  }

  return body && <Alert appearance="warning" body={body} />;
}

CreditReportGeneralAlert.propTypes = {
  applicant: PropTypes.shape({
    userId: PropTypes.string.isRequired,
  }).isRequired,
};

export default CreditReportGeneralAlert;
